<template>
  <div
    style="
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    "
  >
    <div class="list-box" style="flex: 1">
      <ul class="list-search">
        <el-space wrap style="flex: 1">
          <el-date-picker
            v-model="state.params.skssq"
            type="month"
            placeholder="税款所属月份"
            value-format="YYYYMM"
            format="YYYY年M月"
          />
          <el-select
            v-model="state.params.withholding_agent_id"
            placeholder="扣缴义务人"
            style="width: 300px"
          >
            <el-option
              v-for="item in state.withholding_agent_data"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
            <template #footer>
              <el-button size="small" @click="onLoadWithholdingAgent()">
                刷新
              </el-button>
            </template>
          </el-select>
          <el-select
            v-model="state.params.tax_bureau_id"
            placeholder="税局"
            style="width: 200px"
          >
            <el-option
              v-for="item in state.taxbureau_data"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
            <template #footer>
              <el-button size="small" @click="onLoadTaxbureau()">
                刷新
              </el-button>
            </template>
          </el-select>
          <el-dropdown split-button @click="onLoad" type="primary">
            查询
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                  重置
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-space>
        <!-- <el-button
          type="primary"
          :icon="Switch"
          link
          @click="state.showAgent = true"
          disabled
        >
          更新至工资表
        </el-button> -->
      </ul>
      <ul class="list-table">
        <el-table
          ref="tableDom"
          :data="state.tableData"
          v-loading="!Array.isArray(state.tableData)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          :default-sort="{
            prop: state.params.sort_field,
            order:
              state.params.sort_value == 'desc' ? 'descending' : 'ascending',
          }"
          @sort-change="onSortChange"
          @row-click="onRowClick"
        >
          <el-table-column
            fixed
            label="序号"
            width="70"
            type="index"
            :index="
              (index) =>
                (state.params.page - 1) * state.params.limit + index + 1
            "
            align="center"
          />
          <el-table-column
            prop="xm"
            label="姓名"
            :formatter="
              (row, column, cellValue) =>
                $tab_Highlinght(cellValue, state.params.keywords)
            "
            width="120"
            fixed="left"
          />
          <el-table-column label="手机号" width="140">
            <template #default="{ row }">
              <text
                style="color: #1e90ff"
                class="text-hover-decoration"
                title="手机号"
                @click="$onCopy(row.lxdh)"
              >
                {{ row.lxdh }}
              </text>
            </template>
          </el-table-column>
          <el-table-column label="证件号" width="180">
            <template #default="{ row }">
              <text
                style="color: #1e90ff"
                class="text-hover-decoration"
                title="证件号"
                @click="$onCopy(row.zzhm)"
              >
                {{ row.zzhm }}
              </text>
            </template>
          </el-table-column>
          <el-table-column
            prop="update_time"
            label="更新时间"
            :formatter="$tab_TextFormat"
            width="120"
            align="center"
          />
          <el-table-column prop="phone" label="状态" min-width="120">
            <template #default="{ row }">
              <ul
                :style="{ color: row.declare_status == 0 ? '#1e90ff' : '#080' }"
              >
                {{
                  row.declare_status == 0 ? "待更新" : "已更新"
                }}
              </ul>
            </template>
          </el-table-column>
          <el-table-column prop="idtype" label="人员状态" min-width="120">
            <template #default>
              <text>正常</text>
            </template>
          </el-table-column>
          <el-table-column
            prop="withholding_agent_name"
            label="扣缴义务人"
            :formatter="$tab_ShowToolTip"
            min-width="160"
          />
          <el-table-column
            prop="aaa"
            label="统一社会信用代码"
            :formatter="$tab_TextFormat"
            min-width="140"
          />
          <el-table-column
            prop="tax_bureau_name"
            label="税局"
            :formatter="$tab_ShowToolTip"
            min-width="140"
          />
          <el-table-column
            prop="skssq"
            label="税款所属月份"
            :formatter="$tab_TextFormat"
            width="80"
            align="center"
          />
          <el-table-column
            prop="znjyzc"
            label="子女教育"
            :formatter="$tab_PriceFormat"
            align="right"
            width="120"
          />
          <el-table-column
            prop="jxjyzc"
            label="继续教育"
            :formatter="$tab_PriceFormat"
            align="right"
            width="120"
          />
          <el-table-column
            prop="zfzjzc"
            label="住房租金"
            :formatter="$tab_PriceFormat"
            align="right"
            width="120"
          />
          <el-table-column
            prop="sylrzc"
            label="赡养老人"
            :formatter="$tab_PriceFormat"
            align="right"
            width="120"
          />
          <el-table-column
            prop="yyezhzc"
            label="3岁以下婴幼儿照顾"
            :formatter="$tab_PriceFormat"
            align="right"
            width="140"
          />
          <el-table-column
            prop="ljznjyzc"
            label="累计子女教育"
            :formatter="$tab_PriceFormat"
            align="right"
            width="120"
          />
          <el-table-column
            prop="ljjxjyzc"
            label="累计继续教育"
            :formatter="$tab_PriceFormat"
            align="right"
            width="120"
          />
          <el-table-column
            prop="ljzfdklxzc"
            label="累计住房贷款利息"
            :formatter="$tab_PriceFormat"
            align="right"
            width="140"
          />
          <el-table-column
            prop="ljzfzjzc"
            label="累计住房租金"
            :formatter="$tab_PriceFormat"
            align="right"
            width="120"
          />
          <el-table-column
            prop="ljsylrzc"
            label="累计赡养老人"
            :formatter="$tab_PriceFormat"
            align="right"
            width="120"
          />
          <el-table-column
            prop="ljyyezhzc"
            label="累计3岁以下婴幼儿照顾"
            :formatter="$tab_PriceFormat"
            align="right"
            width="170"
          />
          <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
          >
            <template #default="{ row }">
              <el-button
                type="primary"
                link
                icon="Views"
                @click.stop="
                  $store.commit('openMenu', {
                    path: 'EssentialDetail',
                    refresh: true,
                    title: row.xm + '-专项附加扣除明细',
                    data: {
                      id: row.id,
                    },
                  })
                "
              >
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <c_page
          :total="state.totalCount"
          :pageIndex="state.params.page"
          :pageSize="state.params.limit"
          @onLoad="
            (page) => {
              state.params.page = page.pageIndex;
              state.params.limit = page.pageSize;
              onLoad();
            }
          "
        />
      </ul>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  data_withholdingagent_select,
  data_taxbureau_select,
} from "@/http/data";
import { employee_essential_list } from "@/http/employee";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
    name: "",
  };
}
export default {
  props: {
    employee_id: Number,
  },
  setup(props) {
    const tableDom = ref(null);
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.params.employee_id = props.employee_id;

      onLoadWithholdingAgent();
      onLoadTaxbureau();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      employee_essential_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //加载扣缴义务人
    const onLoadWithholdingAgent = () => {
      data_withholdingagent_select().then((res) => {
        if (res.status == 200)
          state.withholding_agent_data = res.data.data?.list;
      });
    };

    const onLoadTaxbureau = () => {
      data_taxbureau_select().then((res) => {
        if (res.status == 200) state.taxbureau_data = res.data.data.list;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //表格行点击事件
    const onRowClick = (row) => {
      tableDom.value.toggleRowSelection(row);
    };

    return {
      state,
      tableDom,
      onLoad,
      onSortChange,
      onReset,
      onLoadWithholdingAgent,
      onLoadTaxbureau,
      onRowClick,
    };
  },
};
</script>
<style scoped></style>
